import { Navigate, Route, Routes } from 'react-router-dom';
import { useMe } from './api/queries';
import { AppShell } from './components/AppShell';
import {
  RedirectIfAuthenticated,
  RequireOperator,
  RequirePcpUser,
  RequireSession,
  RoleGate,
  homeFor,
} from './auth/guards';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { OperatorPage } from './pages/OperatorPage';
import { PlaceholderPage } from './pages/PlaceholderPage';
import { AdminPage } from './pages/AdminPage';
import { ImportPage } from './pages/ImportPage';
import { CadastrosPage } from './pages/cadastros/CadastrosPage';
import { ForcedPasswordPage } from './pages/ForcedPasswordPage';
import { SecurityPage } from './pages/SecurityPage';
import { AuditoriaPage } from './pages/importacao/AuditoriaPage';
import { CargaInicialPage } from './pages/importacao/CargaInicialPage';
import { EmbarquePage } from './pages/importacao/EmbarquePage';
import { ImportacaoPage } from './pages/importacao/ImportacaoPage';

const PCP = ['planner', 'viewer', 'admin'] as const;

function Home() {
  const { data } = useMe();
  return <Navigate to={data ? homeFor(data.perfil) : '/login'} replace />;
}

export function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <RedirectIfAuthenticated>
            <LoginPage />
          </RedirectIfAuthenticated>
        }
      />

      <Route element={<RequireSession />}>
        <Route path="/trocar-senha" element={<ForcedPasswordPage />} />
      </Route>

      <Route element={<RequireOperator />}>
        <Route path="/operador" element={<OperatorPage />} />
      </Route>

      <Route element={<RequirePcpUser />}>
        <Route element={<AppShell />}>
          <Route path="/carga" element={<RoleGate roles={PCP}><PlaceholderPage screen="load" /></RoleGate>} />
          <Route path="/programacao" element={<RoleGate roles={PCP}><PlaceholderPage screen="schedule" /></RoleGate>} />
          <Route path="/carteira" element={<RoleGate roles={PCP}><PlaceholderPage screen="orders" /></RoleGate>} />
          <Route path="/materia-prima" element={<RoleGate roles={PCP}><PlaceholderPage screen="materials" /></RoleGate>} />
          <Route path="/cadastros/*" element={<RoleGate roles={PCP}><CadastrosPage /></RoleGate>} />
          <Route
            path="/importar"
            element={
              <RoleGate roles={['planner', 'admin']}>
                <ImportPage />
              </RoleGate>
            }
          />
          <Route path="/planos" element={<RoleGate roles={PCP}><PlaceholderPage screen="plans" /></RoleGate>} />
          <Route path="/importacao" element={<ImportacaoPage />} />
          <Route path="/importacao/novo" element={<EmbarquePage />} />
          <Route
            path="/importacao/carga-inicial"
            element={
              <RoleGate roles={['importacao', 'admin']}>
                <CargaInicialPage />
              </RoleGate>
            }
          />
          <Route path="/importacao/:nrImport" element={<EmbarquePage />} />
          <Route
            path="/auditoria"
            element={
              <RoleGate roles={['importacao', 'admin']}>
                <AuditoriaPage />
              </RoleGate>
            }
          />
          <Route path="/conta/seguranca" element={<SecurityPage />} />
          <Route
            path="/administracao"
            element={
              <RoleGate roles={['admin']}>
                <AdminPage />
              </RoleGate>
            }
          />
        </Route>
      </Route>

      <Route path="/" element={<Home />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
